import { Grupo } from "./Grupo"
import { Status } from "./Status"

export class Projeto {

public id?: number
public grupo!: Grupo
public cliente?: string
public solucao?: string
public escopo?: string
public origem?: string
public origemComplemento?: string
public ativacao?: string
 public dtcadastro?: Date | null = new Date;
 public dtcontrato?: Date | null
 public dtkickoff?: Date | null
 public dttestunit?: Date | null
 public dttestinteg?: Date | null
 public dtgolive?: Date | null
public status?: Status
public statusDescricao?: string
public statusAndamento?: string
public dtpromocao?: Date
public qtdocorrenciaspendentes?: number
public pesquisaRespondida?: boolean
public contatos?: string;
 public integracao?: string;
public dtatualizacao?: Date | null;

}

export type ProjetoResposta = Omit<Projeto,
  'dtcadastro' | 'dtcontrato' | 'dtkickoff' | 'dttestunit' | 'dttestinteg' | 'dtgolive' | 'dtatualizacao'> & {
  dtcadastro: string | null;
  dtcontrato: string | null;
  dtkickoff: string | null;
  dttestunit: string | null;
  dttestinteg: string | null;
  dtgolive: string | null;
  dtatualizacao: string | null;
};
